//new changes
import React, {useEffect, useRef} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Grid, TextField, Modal } from '@material-ui/core'
import { useDispatch, useSelector } from "react-redux";
import { loadDepartures, loadPaxInfo, changeDepartureDate } from "../../store/departures";
import { loadFlights } from "../../store/flights";
import Chart from "react-google-charts";
import  airportTimezones from "../../utils/airportTimezones.json"
import _ from 'lodash';
import moment from 'moment-timezone'
import { MoveFlightModal } from "./moveFlightModal";

//import TimelineChart
import { TimelineChart } from './timeline/main';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },  
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  header: {
    backgroundColor: 'rgb(117,117,117,1)',
    borderRadius: '0px'
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  buttonCell: {
    width: '7%'
  }
}));

function createData(airline, flightNum, aircraftModel, departure, depDate, arrival, status, key) {
  return {
    airline,
    flightNum,
    aircraftModel,
    departure,
    depDate,
    arrival,
    status,
    key
  };
}

// TODO // put all date functions in a separate file 6/16/2021

const pad = (num) => {
  return Number(num) < 10 ? '0' + num : num
}
const delayedDisplay = (flight) => {
  let output = ``
  if (flight.originalDeparture && flight.airportDepTime && flight.originalDeparture !== flight.airportDepTime) {
    output = `<div style="background-color:#7baaf7;"><b>Original</b>: ${flight.originalDeparture}, <b>Now</b>: ${flight.airportDepTime}</div>`
  }

  
  return output
}

const getDuration = (dep, arr, isText) => {
  let depHrs = Number(dep.substring(0, 2))
  let arrHrs = Number(arr.substring(0, 2))
  let depMins = Number(dep.substring(3, 5))
  let arrMins = Number(arr.substring(3, 5))
  let minDif = arrMins - depMins
  let hrDif
  // NOTE // if the minute difference is negative
  if (minDif < 0) {
    // NOTE // take away an hour
    hrDif = arrHrs - depHrs - 1
    // NOTE // subtract the absolute value of minDif from 60 (i.e. dep: 11:15 arr: 12:05 => hrDif is 1 minDif is -10 => 60 - 10 = 50)
    minDif = 60 - Math.abs(minDif)
  }
  else {
    hrDif = arrHrs - depHrs
  }

  if (isText) {
    return `${hrDif > 0 ? 'hrs:' + pad(hrDif) + ' ' : ''}mins:${pad(minDif)}`
  }
  // NOTE // if isText is false or not there, return a number representing the duration in hours
  else {
    return hrDif + (minDif/60)
  }
}




const formatFlightHtml = (flight, flightDate, pax) => {
  let passengers = flight.PaxList ? flight.PaxList.split(';') : []

  // TODO // look into adding classes to html in Timeline
  let flightHmtl = 
  `<div style="width:250px; height:${125 + (passengers && passengers.length ? (passengers.length * 18) : 0)}px; margin-bottom:5px">
  <div style="background-color:#7baaf7; padding-top:5px; border-bottom:2px solid black; margin-bottom:4px">
    <b>${flight.FlightNumber}</b>
  </div>
  ${delayedDisplay(flight)}
  <b>Flight Dur</b>: ${getDuration(flight.Departure, flight.Arrival, true)} <br/>
   ${formatPax(pax)}
  </div>`

  return flightHmtl
}


export const formatDate = (date, flight, output) => {
  let ETD = flight.ETD ? (flight.ETD.length > 12 ? flight.ETD.slice(12) : flight.ETD) : ''
  let ETA = flight.ETA ? (flight.ETA.length > 12 ? flight.ETA.slice(12) : flight.ETA) : ''
  // NOTE // using isETAfter to check if an ETD/ETA is before the original dep/arr (because that'll break the timeline)
  let fltDeparture = ETD ? ETD : flight.Departure
  let fltArrival = ETA  ? ETA : flight.Arrival
  // NOTE // grab the airport timezones
  let depTz = airportTimezones[flight.Origin]
  flight.Destination = flight.Destination === "HND"?"HSH":flight.Destination
  let arrTz = airportTimezones[flight.Destination]
  // NOTE // set the timezone for the dep/arr
  let depMoment = moment.tz(date + ' ' + fltDeparture, depTz)
  let arrMoment = moment.tz(date + ' ' + fltArrival, arrTz)
  // NOTE // get the airport and user timezone-offsets
  let depOffset = depMoment._offset
  let arrOffset = arrMoment._offset
  let localOffset = new Date().getTimezoneOffset()
  // NOTE // get the difference between user and airport timezone-offsets
  let depDiff = (localOffset + depOffset)/60
  let arrDiff = (localOffset + arrOffset)/60
  let time
  let offsetDif
  // NOTE // set the output info depending on the output prop
  if (output.toUpperCase().includes('DEP')) {
    time = fltDeparture
    offsetDif = depDiff
  }
  else if(output.toUpperCase().includes('ARR')) {
    time = fltArrival
    offsetDif = arrDiff
  }
  // NOTE // get and set the date to return a date-object
  const hours = time.substring(0, 2);
  const min = time.substring(3);
  if (output.toUpperCase().includes('LOCAL')) {
    // FIXME // lines 74-81 changes
    let adjustedHours = hours - offsetDif
    // Handle cases where the adjusted time crosses midnight
  if (adjustedHours < 0) {
    adjustedHours += 24; // Wrap around to the previous day
  } else if (adjustedHours >= 24) {
    adjustedHours -= 24; // Wrap around to the next day
  }
    let newDate = formatTimelineDate(date, adjustedHours, min)
    return newDate
  }
  else {
    let newDate = formatTimelineDate(date, hours, min)
    return newDate
  }
}

const changeDateToLocal = (date) => {
  // NOTE // millis since epoch for the given date
  let localDate = new Date(date)
  // NOTE // time difference between local and UTC in milliseconds
  return localDate
}

// const getFlightDuration = (depDate, arrDate) => {
//   // NOTE // convert dates to milliseconds, and subtract to get the difference
//   let msDifference = new Date(arrDate).getTime() - new Date(depDate).getTime()
//   // NOTE // convert msDifference to minutes
//   let minuteDifference = msDifference/60000
//   // NOTE // get the hour difference and ignore additional minutes
//   let hourDifference = minuteDifference >= 60 ? Math.floor(minuteDifference/60) : 0
//   let formattedDifference = `${hourDifference > 0 ? hourDifference + " hrs" : ''} ${minuteDifference - (hourDifference * 60)} mins`
//   return formattedDifference
// }


const getFlightDuration = (dep, arr, isText) => {
  let depHrs = Number(dep.substring(0, 2))
  let arrHrs = Number(arr.substring(0, 2))
  let depMins = Number(dep.substring(3, 5))
  let arrMins = Number(arr.substring(3, 5))
  let minDif = arrMins - depMins
  let hrDif
  // NOTE // if the minute difference is negative
  if (minDif < 0) {
    // NOTE // take away an hour
    hrDif = arrHrs - depHrs - 1
    // NOTE // subtract the absolute value of minDif from 60 (i.e. dep: 11:15 arr: 12:05 => hrDif is 1 minDif is -10 => 60 - 10 = 50)
    minDif = 60 - Math.abs(minDif)
  }
  else {
    hrDif = arrHrs - depHrs
  }

  if (isText) {
    return `${hrDif > 0 ? 'hrs:' + pad(hrDif) + ' ' : ''}mins:${pad(minDif)}`
  }
  // NOTE // if isText is false or not there, return a number representing the duration in hours
  else {
    return hrDif + (minDif/60)
  }
}


const getDayAfter = (date) => {
  return new Date(new Date(date).getTime() + 86400000).toISOString().slice(0, 10)
}

const formatPax = (pax) => {
  // NOTE // loop over passengers
  let paxStr = ' '
  if (pax && pax.length) {
    for (let i = 0; i < pax.length; i++) {
      const pas = pax[i];
      let paxName = formatName([pas.profile.firstName, pas.profile.lastName])
      let paxRloc = pas.reservation.locator
      paxStr += `<b>pax${i+1}</b>: ${paxName} - ${paxRloc}${pax[i+1] ? '<br/>' : ''}`
    }
  }
  return paxStr
}

const formatName = (nameArr) => {
  for (let i = 0; i < nameArr.length; i++) {
    let name = nameArr[i];
    name = name.toLowerCase()
    // NOTE // new name array? Idk why I called this nna
    let nna = name.split('')
    nna[0] = nna[0].toUpperCase()
    nameArr[i] = nna.join('')
  }
  return nameArr.join(' ')
}

const formatTimelineDate = (date, hours, mins) => {
  let dateArr = date.split('-')
  dateArr[0] = Number(dateArr[0])
  dateArr[1] = Number(dateArr[1]) - 1
  dateArr[2] = Number(dateArr[2])
  return new Date(dateArr[0], dateArr[1], dateArr[2], Number(hours), Number(mins))
}
const formatDepartureDate = (date) => {
  let dateArr = date.split('-')
  dateArr[0] = Number(dateArr[0])
  dateArr[1] = Number(dateArr[1]) - 1
  dateArr[2] = Number(dateArr[2])
  return new Date(dateArr[0], dateArr[1], dateArr[2], 0, 0)
}
function generateRandomFlightId() {
  return Math.floor(Math.random() * 1000000); // Generates a random number as fltid
}


function transformFlightData(flightDatas, paxInfo) {
  try {
    const transformedData = flightDatas?.map((flightData)=>{ 
      const flightNumber = `${flightData?.flightStatus?.airlineCode?.code || ""}${flightData?.flightStatus?.flightNumber || ""}`;
      const origin = flightData?.flightStatusLeg?.flightLeg?.departure?.airport?.code || "";
      const destination = flightData?.flightStatusLeg?.flightLeg?.arrival?.airport?.code || "";
      const departure = flightData?.flightStatusLeg?.departure?.localActualOffShortTime || "";
      const arrival = flightData?.flightStatusLeg?.arrival?.localActualInShortTime || "";
      const tailNumber = flightData?.flightStatusLeg?.aircraftModel?.identifier || flightData?.flightStatus?.flightNumber || "";
      let pax =  paxInfo[flightData.key]?.passengers
      return {
          FlightNumber: flightNumber,
          Origin: origin,
          Destination: destination,
          Departure: departure,
          Arrival: arrival,
          Load: "0/8", // Hardcoded as per your requirement
          TailNumber: tailNumber,
          PIC: "", // Empty string for PIC
          SIC: "", // Empty string for SIC
          NOPAX: "0", // Empty for NOPAX
          PaxList: "", // Empty string for PaxList
          DCSFltStatus: "", // Empty for DCSFltStatus
          Region: "Caribbean", // Assuming the region is Caribbean based on your example
          ETD: "", // Empty for ETD
          ETA: "", // Empty for ETA
          fltid: generateRandomFlightId(), // Random flight ID
          comment: "" // Empty comment
      };
    })
    return transformedData
  } catch (error) {
      console.error("Error transforming flight data:", error);
      return {}; // Return empty object if an error occurs
  }
}



export default function FlightOpsV2() {
  const dispatch = useDispatch()
  const departures = useSelector(state => state.entities.departures.list);
  
  const paxInfo = useSelector(state => state.entities.departures.paxInfo)

  const depDate = useSelector(state => state.entities.departures.departureDate);
  const flightDate = useSelector(state => state.entities.departures.departureDate);
  const loading = useSelector(state => state.entities.departures.loading)
  const timelineDate = formatDepartureDate(depDate)
  const [selectRow, setSelectRow] = React.useState(null)
  const [isModalOpen, setModal] = React.useState(false)
  const classes = useStyles();
  const [loadPax, setLoadPax] = React.useState(true)
  const ref = useRef(0)



  const loadAllPaxInfo = () => {
    // NOTE // gets the departure info for display
    for (let i = 0; i < departures.length; i++) {
      const depKey = departures[i].key;
      dispatch(loadPaxInfo(depKey))
    }
    setLoadPax(false)
  }

  const flights = transformFlightData(departures, paxInfo);

  useEffect(() => {
    dispatch(loadDepartures(depDate));
    // NOTE // gets flights using the departure date and day after for handleMoveFlight
    // NOTE // departures with the date set to 2021-01-01 does not get the same results as flights with earliestDeparture and latestDeparture set to 2021-01-01
    dispatch(loadFlights(depDate, getDayAfter(depDate)));
  }, [depDate]);
  

  const GChart = (props) => {
    let formattedDeps = formatTimelineData(props.departures)

    return (
      <div>
        <Chart 
        // key = {chartKey}
        chartType="Timeline" 
        width="100%" 
        height="90vh" 
        options={{
          timeline: {
            singleColor: "#9fc5e9",
            
            showRowLabels: true, // Ensure that row labels are visible
            tooltip: { isHtml: true }, // Enable HTML tooltips if necessary
          },
          
        }}
        alternatingRowStyle={false}
        avoidOverlappingGridLines={true}
        backgroundColor="#fff"
        style={{font: 'message-box'}}

        data={formattedDeps}
        // TODO // reimplement when/if we can move flight times
        chartEvents={[
          {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
              const chart = chartWrapper.getChart();
              google.visualization.events.addListener(chart, "select", e => {
                let selectedRow = chart.getSelection()[0].row
                if (selectedRow || selectedRow === 0) {
                  setSelectRow(selectedRow)
                  setModal(true)
                }
              });
            }
          }
        ]}
        />
      </div>
    )
  }
  const FlightChart = () => {

  
  // NOTE // formatting flight times for Timeline
  /**
   * Change the formatTimeLineFlights
   * update the if class check the arrival.estimatedTime, departure.estimatedTime 
   *  took original departure - localActualOffShortTime
   *  took original arrival - localActualOnShortTime
   *  Departure value slice -  departure.estimatedTime
   *  arrival value slice - arrival.estimatedTime
   *  schedule time departure - 
   *  schedule time arrival -
   * */

  const isFlightOpen = (flight) => {
    if (flight && !!flight.DCSFltStatus) {
      // FIXME // getting occasional error for betterRow.status
      // NOTE // 10 is closed, 5 or '' is open
      let dcsStatus = flight.DCSFltStatus
      if (dcsStatus === '10') {
        return false
      }
      else {
        return true
      }
    }
    return true
  }

  const getFlightStatus = (flight, isStatus) => {
    let overlaps = []
    let curFlight
    // NOTE // inside the chart the item is being passed with some new properties to check for overlaps
    if (flight.item) {
      overlaps = flight.overlaps
      curFlight = flight.item
    }
    else {
      curFlight = flight
    }
    
    let ETD = curFlight.ETD
    let ETA = curFlight.ETA
    let dep = curFlight.originalDeparture ? curFlight.originalDeparture : curFlight.Departure
  
    // NOTE // priority is cancelled, overlapping, delayed, active
    if (curFlight.NOPAX === "1") {
      return !isStatus ? 'rgb(234, 152, 154)' : 'Cancelled'
    }
    // NOTE // if the flight has an estimated time of departure (ETD) and an estimated time of arrival (ETA), it is probably delayed
    else if (ETD && ETA) {
      if (overlaps.length > 0) {
        return !isStatus ? 'orchid' : 'Active'
      }
      let ETDTime = new Date(ETD).getTime()
      // NOTE // gets the time for the departure using the day from ETD (estimated time of departure)
      let depTime = new Date((ETD.slice(0, 11) + ' ' + dep)).getTime()
      // NOTE // if the estimated time of departure is after departure make it orange to indicate it's delayed
      if (ETDTime > depTime) {
        // NOTE // delayed is still considered active as far as filtering is concerned
        return !isStatus ? 'orange' : 'Active'
      } else if(depTime > ETDTime) {
        return !isStatus ? 'yellow' : 'Active'
      }
      // NOTE // if there is an ETA/ETD that are the same as the original arrival/dep time, it's active
      return !isStatus ? '#9fc5e9' : 'Active'
    }
    else if (overlaps.length > 0) {
      return !isStatus ? 'orchid' : 'Active'
    }
    else {
      return !isStatus ? '#9fc5e9' : 'Active'
    }
  }

  const formatFlightLabel = (flight, pax) => {
    // NOTE // formatDate returns a date-object, the substring part returns 'HH:MM' formatting
    let departure = formatDate(flightDate, flight, 'dep').toString().substring(16, 21)
    let arrival = formatDate(flightDate, flight, 'arr').toString().substring(16, 21)
    let userDepartTime = formatDate(flightDate, flight, 'localDep').toString().substring(16, 21)
    let userArriveTime = formatDate(flightDate, flight, 'localArr').toString().substring(16, 21)
    let flightColor = isFlightOpen(flight) ? 'white' : 'black'
    // NOTE // if any of these are present (SA, MM, PN) it will make an array out of it
    let hasStandbyPax = flight.PaxList.match(/\- (SA|MM|PN)/g)
    console.log("flight.PaxList",flight.PaxList);
    console.log("hasStandbyPax",hasStandbyPax);
    let paxlength = 0
    if(pax && pax.length){
      paxlength = pax.length
    }
    let flightLabelArr = [
      {
        text: [`${flight.FlightNumber}  `, ` `],
        styles: [
          {fontWeight: 'bold', marginRight: '3px'},
          // NOTE // this is the open/closed indicator
          {fontWeight: 'bold', border: '1px solid black', borderRadius: '85px', height: '8px', width: '8px', marginTop: '4px', backgroundColor: flightColor},
          {height: '15px'}
        ]
      },
      {
        text: [`no of pax: ${paxlength}`,`${hasStandbyPax ? `STBY` : ''}`, `${hasStandbyPax ?  `(${hasStandbyPax.length})` : ''}`],
        styles: [{}, {fontWeight: 'bold', marginLeft: '3px', marginRight: '3px', color: '#bb0000'}, {}]
      },
      {text: [`${flight.Origin} ${departure} (${userDepartTime})`], styles: [{}]},
      {text: [`${flight.Destination} ${arrival} (${userArriveTime})`], styles: [{}]}
    ]

    return flightLabelArr
  }

   // NOTE // filtering flights before handing them off to Timeline
   const filterFlights = (flights) => {
    let flightsCopy = _.cloneDeep(flights)
    let filteredFlights = []
    let filters = [{property: 'Origin', list: []}, {property: 'Destination', list: []}, {property: 'Status', list: ["Active"]}, {property: 'Region', list: []}]
    // NOTE // loop over flights
    for (let i = 0; i < flightsCopy.length; i++) {
      const flight = flightsCopy[i];
      let flightStatus = getFlightStatus(flight, true)
      // NOTE // loop over each filter
      for (let j = 0; j < filters.length; j++) {
        const filter = filters[j];
        let property = filter.property
        // NOTE // if there is anything selected for this filter
        if (filter.list.length) {
          // NOTE // true if the flight has the filter value
          let keep = filter.property !== 'Status' ? filter.list.includes(flight[property]) : filter.list.includes(flightStatus)
          if (!keep) {
            // NOTE // filteredFlights is what we are NOT using
            filteredFlights.push(flight.fltid)
          }
        }
      }
    }

    return flightsCopy.filter(f => !filteredFlights.includes(f.fltid))
  }
  
    // NOTE // gets the beginning OR end date for the timeline
    const getTimelineTimes = (flights, isStart) => {
      let flightTimes = _.cloneDeep(flights)
      // NOTE // getting the times for comparison, then sort them
      flightTimes = isStart ? flights.map(flt => formatDate(flightDate, flt, 'localDep').getTime()).sort() : flights.map(flt => formatDate(flightDate, flt, 'localArr').getTime()).sort()
      // NOTE // get the first or last flight-time depending on isStart
      let time = flightTimes[isStart ? 0 : flightTimes.length - 1]
  
      time = new Date(time).getHours()
      return time
    }
  



  // NOTE // formatting flight times for Timeline
  const formatTimlineFlights = (flights) => {
    let formattedFlights = []
    // TODO // filter flights here
    let flightsCopy = _.cloneDeep(flights)
    let filteredFlights = filterFlights(flightsCopy)

    for (let i = 0; i < filteredFlights.length; i++) {
      let flight = filteredFlights[i];
      // NOTE // if the flight has an ETD/ETA, it means the flight has been moved and the ETD/ETA should be shown in the chart
      if (flight.ETA && flight.ETD) {
        // NOTE // originalDeparture/originalArrival are the airports original scheduled time
        flight.originalDeparture = flight.Departure
        flight.originalArrival = flight.Arrival
        // NOTE // Departure/Arrival are the current local (not airport) times
        flight.Departure = flight.ETD.slice(12)
        flight.Arrival = flight.ETA.slice(12)
        // NOTE // airportDepTime/airportArrTime are the current airport times
        flight.airportDepTime = flight.Departure
        flight.airportArrTime = flight.Arrival
      }
      else {
        flight.originalDeparture = flight.Departure
        flight.originalArrival = flight.Arrival
        flight.airportDepTime = flight.Departure
        flight.airportArrTime = flight.Arrival
      }
      const departure = departures[i];
      let paxLoc = paxInfo.findIndex(p => p.key == departure.key)
      let pax = paxLoc != -1 ? paxInfo[paxLoc].passengers : []
      flight.label = formatFlightLabel(flight, pax)
      flight.hoverHtml = formatFlightHtml(flight, flightDate, pax)
      flight.Departure = formatDate(flightDate, flight, 'localDep')
      flight.Arrival = formatDate(flightDate, flight, 'localArr')
      flight.PaxList = formatPax(flight.PaxList ? flight.PaxList.split(';') : [])
      flight.key = flight.fltid
      formattedFlights.push(flight)
    }

    return formattedFlights
  }

    // NOTE // configuring chart-width so that all flights show all their info (just so happens to be 100px exactly)
    const configureChartWidth = (flights) => {
      let flightsCopy = _.cloneDeep(flights)
      let timelineStart = getTimelineTimes(flightsCopy, true)
      let timelineEnd = getTimelineTimes(flightsCopy, false)
      // NOTE // flight labels take up 1/12 of the total chart width, while the rows take up the other 11/12
      // NOTE // the amount of hours from the first flight to the last (the +2 is to include the 1st and last hour)
      let chartTime = timelineEnd - timelineStart + 2
      // NOTE // get the shortest flight duration in hours
      let shortestFlt = 100
      for (let i = 0; i < flightsCopy.length; i++) {
        const flt = flightsCopy[i];
        let fltDep = flt.ETD ? flt.ETD.slice(12) : flt.Departure
        let fltArr = flt.ETA ? flt.ETA.slice(12) : flt.Arrival
        let fltDuration = getFlightDuration(fltDep, fltArr)
        // NOTE // replaces shortestFlt if the fltDuration is lower or if shortestFlt isn't set
        shortestFlt = fltDuration < shortestFlt ? fltDuration : shortestFlt
      }
      console.log(shortestFlt)
      // NOTE // 100/shortestFlt gives the length an hour needs to be to show all flt info, Math.floor(nums) + 1 because you can't see a 10th of a pixel
      let hourWidth = Math.abs((Math.floor(110/shortestFlt) + 1) * (12/11))
      console.log('hourWidth', hourWidth)
      console.log('return ', ((chartTime * hourWidth) + 1))
      return Math.floor(chartTime * hourWidth) + 1
    }
  
    return(
      <Grid container>
      {/* <Filters filters={filterProps} flights={flights} classes={classes} isMobile={isMobile} /> */}
      <Grid container ref={ref}>
          {
            flights && flights.length && ref.current.offsetWidth && !loading ?
            // <div id="chartWrapper" style={{ overflowX: 'scroll', overflowY: 'visible', width: (ref.current.offsetWidth + 'px')}}>
             <div id="chartWrapper" className='flightTimelineScroll' style={{ overflowX: 'auto', overflowY: 'auto', width: '100%'}}> 
              <TimelineChart
                items={formatTimlineFlights(flights)}
                timelineDate={timelineDate}
                timelineStart={getTimelineTimes(flights, true)}
                //timelineStart={0}
                timelineEnd={getTimelineTimes(flights, false)}
                dateItemsLoc={['Departure', 'Arrival']}
                vAxisProp={'FlightNumber'}
                chartHeight={900}
                chartWidth={configureChartWidth(flights)}
                // chartWidthRef={ref.current.offsetWidth}
                showCurTime={flightDate === new Date().toISOString().slice(0, 10)}
                itemOptions={
                  {
                    defaultColor: '#9fc5e9',
                    colorIf: getFlightStatus,
                    hover: 'hoverHtml',
                    // itemStyle:isMobileView ? {height: '64px', top: '25%', fontFamily: 'Helvetica',width:'140px'} : {height: '64px', top: '25%', fontFamily: 'Helvetica'}
                  }
                }
                labelOptions={
                  {
                    label: 'label'
                  }
                }
                // itemModal={
                //   {
                //     component: <FlightModal flightDate={flightDate} editStatus={editReqStatus}/>
                //   }
                // }
              />
            </div>
             :
            <Grid container justify='center' alignContent='center' item xs={12} style={{height: '200px'}}>
              <h2>
                {loading ? 'loading...' : 'There are no flights for this date'}
              </h2>
            </Grid>
          }
      </Grid>
    </Grid>
    )
  }

  const changeDepartureDateRq = (event) => {
    dispatch(changeDepartureDate(event.target.value))
  }

  // NOTE // limiting the amount of re-renders/requests
  if (loadPax) {
    loadAllPaxInfo()
  }

  const formatTimelineData = (departures) => {
    // NOTE // id is basically a label
    let headers = [{type: 'string', id: 'Flight Number'}, { type: 'string',  id:"label" }, {type: 'string', role: 'tooltip'}, {type: 'date', id: 'Start'}, {type: 'date', id: 'End'}]
    let formattedData = [headers]
    for (let i = 0; i < departures.length; i++) {
      // TODO // passenger names
      const departure = departures[i];
      let paxLoc = paxInfo.findIndex(p => p.key == departure.key)
      let pax = paxLoc != -1 ? paxInfo[paxLoc].passengers : []
      let flightDuration = getFlightDuration(departure.flightStatusLeg.departure.estimatedTime, departure.flightStatusLeg.arrival.estimatedTime)
      let tooltip = `<div style="width:235px;height:${11 + (pax && pax.length ? (pax.length * 1.17) : 0)}em;margin-bottom:5px">
      <div style="background-color:#7baaf7;padding-top:5px;border-bottom:2px solid black;margin-bottom:4px">
      <b>Flight Number</b>: ${departure.flightStatus.flightNumber}<br/>
      </div>
      <b>Flight Duration</b>: ${flightDuration}<br/>
      <b>User Depart Time</b>: ${formatDate(changeDateToLocal(departure.flightStatusLeg.departure.estimatedTime))}<br/>
      <b>User Arrive Time</b>: ${formatDate(changeDateToLocal(departure.flightStatusLeg.arrival.estimatedTime))}<br/>
      <b>Depart Time</b>: ${formatDate(departure.flightStatusLeg.departure.localEstimatedTime)}<br/>
      <b>Arrival Time</b>: ${formatDate(departure.flightStatusLeg.arrival.localEstimatedTime)}<br/>
      <b>Depart City</b>: ${departure.flightStatusLeg.departure.airport.code}<br/>
      <b>Arrival City</b>: ${departure.flightStatusLeg.arrival.airport.code}<br/>
      ${formatPax(pax)}
      </div>`
      //`${departure?.flightStatus?.airlineCode?.code}${departure?.flightStatus?.flightNumber}`
      let flightData = [departure.flightStatus.flightNumber,`${departure?.flightStatus?.airlineCode?.code}${departure?.flightStatus?.flightNumber}`,   tooltip, changeDateToLocal(departure.flightStatusLeg.departure.estimatedTime), changeDateToLocal(departure.flightStatusLeg.arrival.estimatedTime)]
      formattedData.push(flightData)
    }
    return formattedData
  }

  return (
    <div>
      {
      !isNaN(selectRow) ? 
      <Modal
        open={isModalOpen}
        onClose={() => {setModal(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <MoveFlightModal dep={departures[selectRow]} depDate={depDate} closeModal={setModal} />
      </Modal> : 
      <div></div>
      }
      <Grid container xs={12} style={{marginBottom: '15px'}}>
        <form className={classes.container} noValidate>
          <TextField
            id="depDate"
            label="Departure Date"
            type="date"
            defaultValue={depDate}
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={changeDepartureDateRq}
          />
        </form>
      </Grid>
      {/* <GChart departures={departures} /> */}
      <FlightChart/>
      {/* FIXME // chart gets messed up on nav-drawer open/close */}
      {/* NOTE // works better with fixed height. Will NOT adjust based on number of flights*/}
    </div>
  )
}
